// event 7029 รวม ADAS / DMS / กล้อง AI ไว้ด้วยกัน แยกกันด้วย category
// (ตาราง adas_event_types — type = 'ADAS' | 'DMS' | 'AI')
export const ADAS_DMS_EVENT_TYPE = 7029
export const AI_CATEGORY = 'AI'

export const isAiCameraEvent = ele =>
  ele.eventType == ADAS_DMS_EVENT_TYPE && ele.category === AI_CATEGORY

export const isAdasDmsEvent = ele =>
  ele.eventType == ADAS_DMS_EVENT_TYPE && !isAiCameraEvent(ele)
